import { type JurisdictionApi } from '@api/jurisdictions';

import { jurisdictionItemModel, type Jurisdiction } from '../jurisdictionItem';

/**
 * Transforms a list of jurisdictions from API
 */
export const getJurisdictionsListModel = (data: Array<JurisdictionApi>): Array<Jurisdiction> =>
  data.map(jurisdiction => jurisdictionItemModel(jurisdiction));
